import * as React from "react";
import AttributeList from "../../presentations/AttributeList";

const AttributeListContainer = (props: any) => {

  const { onEdit } = props;

  const handleOnEdit = (rowData: any) => {
    onEdit(rowData);
  }

  return (
    <div>
      <AttributeList onEdit={handleOnEdit}></AttributeList>
    </div>
  );
};

export default AttributeListContainer;
